import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1160px;

  > h1 {
    text-align: center;
    margin-bottom: 32px;
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  justify-content: center;

  @media (min-width: 640px) {
    justify-content: start;
  }
`;

export const FilterDelivery = styled.form`
  margin-bottom: 24px;
  border-radius: 10px;
  border: 1px solid #9d9d9d;
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  grid-template-areas: "uf" "cidade" "buttons";
  padding: 32px 16px;

  > :nth-child(1) {
    grid-area: uf;
  }

  > :nth-child(2) {
    grid-area: cidade;
  }

  > :nth-child(3) {
    grid-area: buttons;
    display: flex;
    gap: 0 16px;
    justify-content: center;
  }

  @media (min-width: 640px) {
    padding: 32px;
    width: 100%;
    max-width: 730px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: "uf cidade buttons";
  }
`;

export const Table = styled.div`
  margin-bottom: 32px;

  div + div {
    margin-top: 16px;
  }
`;

export const TableItem = styled.div`
  border-radius: 10px;
  background: #e8e8e8;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 0.1fr;
  grid-template-areas: "cidade olho" "status status";

  > :nth-child(1) {
    grid-area: cidade;
  }

  > :nth-child(2) {
    grid-area: status;
  }

  > :nth-child(3) {
    grid-area: olho;
  }

  > p {
    color: #2d2d2d;
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0.36px;
    text-transform: uppercase;

    span {
      font-weight: 400;
    }
  }

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr 0.1fr;
    grid-template-areas: "cidade status olho";
  }
`;
